import { api } from './api';

export interface QuestType {
  active: boolean;
  cost: number;
  created: number;
  fund: number;
  fund_size: number;
  image: string;
  log: number;
  owner: string;
  owner_name: string;
  socialMedia: string;
  title: string;
  type: string;
  updated: number;
  value: string;
  _id: string;
}

export async function getSkillQuests() {
  const payload = [
    {
      $lookup: {
        from: 'labs__c',
        localField: '_id',
        foreignField: 'parent',
        as: 'labs',
      },
    },
    {
      $lookup: {
        from: 'challenges__c',
        localField: '_id',
        foreignField: 'parent',
        as: 'challenges',
      },
    },
  ];

  const { data } = await api.post<[QuestType]>('/database/skill_quest__c/aggregate', payload);

  return data;
}

export async function getQuest(player: string, type: string) {
  const payload = { type, player };

  const { data } = await api.post<[QuestType]>('/find/social_quests', payload);
  return data;
}
export async function getPurchaseQuest(player: string) {
  const { data } = await api.post<[QuestType]>('/find/purchase_quests', {
    player,
  });
  return data;
}

export async function getTotalAvailableQuests(player: string) {
  const quest: any = await api.post<any>(
    '/find/social_quests',
    { player },
    {
      headers: {
        range: 'items=0-1',
      },
    },
  );
  const quiz: any = await api.post<any>(
    '/find/quiz_quests',
    { player },
    {
      headers: {
        range: 'items=0-1',
      },
    },
  );
  const purchase: any = await api.post<any>(
    '/find/purchase_quests',
    { player },
    {
      headers: {
        range: 'items=0-1',
      },
    },
  );

  return (
    quest.headers['content-range'].split('/')[1] * 1 +
    quiz.headers['content-range'].split('/')[1] * 1 +
    purchase.headers['content-range'].split('/')[1] * 1
  );
}


export async function getAnswersQuiz() {
  const { data } = await api.post('/find/get_new_year_data', {  });
  return data;
}